import Http from '@/classes/http/Http'

export default {
  getServices () {
    return Http.get({
      url: 'services'
    })
  }
}
